module.exports = __webpack_public_path__ + "static/media/logo1.983a4504.png";